import {
  AuthorizedApiService,
  AuthorizedFormApiService,
} from "../../../services/apiServices";
import { notification } from "antd";

import { GET_MANUALS, UPLOAD_MANUAL } from "./types";

export const uploadManual = (manual, role) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("pdf", manual);
    formData.append("userRole", role);

    dispatch({
      type: UPLOAD_MANUAL,
      payload: role,
    });

    AuthorizedFormApiService.post("manual", formData)
      .then((res) => {
        const { status, data } = res;
        if (status !== 201) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }

        notification.success({
          message: "Manual created",
        });

        dispatch(getManuals());

        dispatch({
          type: UPLOAD_MANUAL,
          payload: null,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPLOAD_MANUAL,
          payload: null,
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
    dispatch({
      type: UPLOAD_MANUAL,
      payload: null,
    });
    console.log(err);
  }
};

export const getManuals = () => async (dispatch) => {
  try {
    AuthorizedApiService.get("/manual/all")
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        dispatch({
          type: GET_MANUALS,
          payload: data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {
    notification.error({
      message: "Something went wrong",
    });
    console.log(error);
  }
};

export const manualDelete = (id) => async (dispatch) => {
  try {
    AuthorizedApiService.delete(`manual/${id}`)
      .then((res) => {
        const { status } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        notification.success({
          message: "Manual deleted",
        });
        dispatch(getManuals());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
  }
};
